import { cn } from '@prenuvo/halo-foundation';

import { useFormStructure } from '@/shared/guard';
import { Skeleton } from '@/shared/ui';

import { NavMenuLink } from './nav-menu-link.component';

export function NavMenu() {
  const { links } = useFormStructure();

  const previewLink = links.find((link) => link.key === 'preview')!;

  return (
    <nav
      className={cn(
        'rounded-2xl bg-stone-900 dark:bg-stone-900 pr-1 pt-1 overflow-hidden h-full flex flex-col justify-between w-[220px]',
      )}
    >
      {links.length === 0 ? (
        <div className="mt-2 flex flex-col gap-4 overflow-y-auto px-2">
          <Skeleton className="h-8" count={24} />
        </div>
      ) : (
        <div className="custom-scrollbar grid w-full grid-flow-row auto-rows-max grid-cols-none gap-1 overflow-y-auto overflow-x-hidden pb-3">
          {links
            .filter(({ key }) => key !== 'preview')
            .map((link, index) => (
              <NavMenuLink key={link.key} index={index} isSubmenuItem={false} link={link} />
            ))}
        </div>
      )}
      <div>
        <div className="border-t border-stone-700 py-1 dark:border-stone-700">
          <NavMenuLink index={0} isSubmenuItem={false} link={previewLink} />
        </div>
      </div>
    </nav>
  );
}
